module.exports = __webpack_public_path__ + "img/t-shirt-5.c7da5637.png";